import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import CommonModal from "../../components/shared/modalLayout/CommonModal";
import InputWithLabel from "../../components/shared/fields/InputWithLabel";
import SelectBox from "../../components/shared/fields/SelectBox ";
import Button from "../../components/shared/buttons/button";
import useTranslator from "../../hooks/useTranslator";
import { useCreateMixingLogMutation, useGeneratePastingBatchCodeQuery, useUpdateMixingLogMutation } from "./mixingApi";
import { getCurrentDate } from "../../helpers/Utils";

const STATUS_OPTIONS = [
  { value: "pre_mix", label: "Pre Mix" },
  { value: "mixing",  label: "Mixing" },
  // { value: "packed",  label: "Packed" },
];

const initialForm = {
  date: getCurrentDate("YYYY-MM-DD"),
  batch_code: "",
  kg_entered: "",
  water_weight: "",
  total_weight: "",
  status: "pre_mix",
};

const MixingModal = ({ show, setShow, record, mode, lotNumber }) => {
  const { _t } = useTranslator();
  const [formData, setFormData] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [createMixingLog, { isLoading: isCreating }] = useCreateMixingLogMutation();
  const [updateMixingLog, { isLoading: isUpdating }] = useUpdateMixingLogMutation();

  const { data:generatedBatchCode , isFetching : isBatchCodeFetching } = useGeneratePastingBatchCodeQuery({batch_code : lotNumber  },{refetchOnMountOrArgChange: true ,   skip: mode !== "add" });
  
  // console.log(generatedBatchCode);
  
  useEffect(() => {
    if (record && mode === "edit") {
      setFormData({
        date:         record.date         || getCurrentDate("YYYY-MM-DD"),
        batch_code:   record.batch_code   || "",
        kg_entered:   record.kg_entered   || "",
        water_weight: record.water_weight || "",
        total_weight: record.total_weight || "",
        status:       record.status       || "pre_mix",
      });
    } else {
      setFormData({ ...initialForm, batch_code: lotNumber ? String(lotNumber) : "" });
    }
  }, [record, mode, show, lotNumber]);

  const handleClose = () => setShow(false);
  const isLockedByRecord = record?.status === "mixing" || record?.status === "packed" ;
  const isMixing = isLockedByRecord;
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
    if (errors[name]) setErrors((p) => ({ ...p, [name]: "" }));
  };

  useEffect(() => {
    const kg = parseFloat(formData.kg_entered) || 0;
    const water = parseFloat(formData.water_weight) || 0;
    setFormData((p) => ({ ...p, total_weight: (kg + water).toFixed(2) }));
  }, [formData.kg_entered, formData.water_weight]);


  useEffect(() => {
    if(mode === "add"){
      setFormData((p) => ({
        ...p,
        batch_code: generatedBatchCode?.data
      }));
    }
  }, [generatedBatchCode ,mode]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isCreating || isUpdating) return;

    if (!formData.kg_entered || parseFloat(formData.kg_entered) < 1) {
      setErrors({ kg_entered: _t("kg_entered_min", "KG Entered must be at least 1") });
      return;
    }
    setErrors({});
    const payload = {
      ...formData,
      kg_entered:   parseFloat(formData.kg_entered)   || 0,
      water_weight: parseFloat(formData.water_weight) || 0,
      total_weight: parseFloat(formData.total_weight) || 0,
    };
    try {
      if (mode === "edit") await updateMixingLog({ id: record.id, requestBody: payload }).unwrap();
      else await createMixingLog(payload).unwrap();
      handleClose();
    } catch (error) {
      console.error("Error saving mixing log:", error);
    }
  };

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={mode === "edit" ? _t("edit_mixing_log", "Edit Mixing Log") : _t("add_mixing_log", "Add Mixing Log")}
    >
      <Row>
        <Col lg={6}>
          <InputWithLabel label={_t("date", "Date")} type="date" name="date" value={formData.date} onChange={handleChange} disabled={true} />
        </Col>
        <Col lg={6}>
          <InputWithLabel label={_t("batch_code", "Batch Code")} type="text" name="batch_code" value={formData.batch_code} onChange={handleChange} placeholder="Batch code" disabled={true} />
        </Col>
        <Col lg={6}>
          <InputWithLabel label={_t("kg_entered", "KG Entered")} type="number" name="kg_entered" value={formData.kg_entered} onChange={handleChange} placeholder="0" disabled={isMixing} error={errors.kg_entered} />
        </Col>
        <Col lg={6}>
          <InputWithLabel label={_t("water_weight", "Water Weight")} type="number" name="water_weight" value={formData.water_weight} onChange={handleChange} placeholder="0" disabled={isMixing} />
        </Col>
        <Col lg={6}>
          <InputWithLabel label={_t("total_weight", "Total Weight")} type="number" name="total_weight" value={formData.total_weight} onChange={handleChange} placeholder="0" disabled={true} />
        </Col>
        <Col lg={6}>
          <SelectBox label={_t("status", "Status")} name="status" value={formData.status} onChange={handleChange} options={STATUS_OPTIONS} disabled={isMixing} />
        </Col>
      </Row>
      <Row>
        <Col className="text-end">
          {!isMixing && (
            <Button label={_t("save_changes", "Save Changes")} size="small" onClick={handleSubmit} disabled={isCreating || isUpdating || isBatchCodeFetching} />
          )}
        </Col>
      </Row>
    </CommonModal>
  );
};

export default MixingModal;
